
import { defineComponent, reactive, computed, PropType, watch, ref } from "vue";
import {
  ErrorMessageFilter,
  IErrorResponse,
  isErrors,
  IUser,
  consts,
} from "@/services/Models";
import ErrorMessage from "@/components/ErrorMessage.vue";
import { AxiosResponse } from "axios";

export default defineComponent({
  name: "AdminContractUserEdit",
  components: { ErrorMessage },
  props: {
    isShowModal: { type: Boolean },
    isDeleteMode: { type: Boolean },
    editModel: { type: Object as PropType<IUser> },
    apply: { type: Function as PropType<(u: IUser) => Promise<void>> },
  },
  setup(props, context) {
    const isShowModalInner = computed({
      get: () => props.isShowModal,
      set: (newValue) => {
        context.emit("update:isShowModal", newValue);
      },
    });
    const errors = ref<IErrorResponse[]>([]);
    const errorMessages = computed(() => ({
      email: ErrorMessageFilter(errors.value, "Mail"),
    }));

    const user = reactive({
      email: "",
      name: "",
    });
    const update = () => {
      if (!props.editModel) return;
      if (!props.isShowModal) return;
      user.email = props.editModel.email;
      user.name = props.editModel.name;
    };
    // 対象のユーザをウォッチして変更があればユーザ情報を更新する
    watch(() => props.editModel, update);
    watch(() => props.isShowModal, update);
    watch(
      () => isShowModalInner.value,
      (newVal) => {
        if (!newVal) {
          errors.value = [];
        }
      }
    );

    // ユーザ情報をDBへ登録する
    const applyInner = async () => {
      if (!props.editModel) return;
      if (!props.apply) return;
      props
        .apply({
          id: props.editModel.id,
          name: user.name,
          email: user.email,
          role: props.editModel.role,
        })
        .then(() => {
          isShowModalInner.value = false;
          errors.value = [];
        })
        .catch((ex: AxiosResponse) => {
          if (isErrors(ex.data)) {
            errors.value = ex.data as IErrorResponse[];
          } else {
            alert(consts.updateContractFailure);
          }
        });

      // context.emit("apply");
    };
    // ユーザ情報をDBから削除する
    const remove = async () => {
      if (!props.editModel) return;
      context.emit("remove", {
        id: props.editModel.id,
        name: props.editModel.name,
        email: props.editModel.email,
      });
      isShowModalInner.value = false;
    };
    return {
      isShowModalInner,
      user,
      applyInner,
      remove,
      errorMessages,
      consts,
    };
  },
});
